/**
 * Általános highcharts direktíva, ami paraméterben kapja meg
 * az összes beállítást (chart típus, adatok, stb.)
 * @param app
 * @author laci
 */
export default function (app) {
	app.directive('hcChart', function () {
		return {
			restrict: 'A',
			scope: {
				options: '='
			},
			link: function (scope, element) {
				Highcharts.chart(element[0], scope.options);

				scope.$watch('options', function () {
					Highcharts.chart(element[0], scope.options);
				});
			}
		};
	});
};
